import { AzureDataExplorerDataset, IModel, IAttribute, Metamodel } from 'shell-models-lib';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureDataExplorer.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureDataExplorerDataset) }
})
export class AzureDataExplorerCopySink extends CopySink {
    public static readonly MODEL: IModel;
    public static readonly INGESTION_MAPPINGNAME: IAttribute;
    public static readonly ADDITIONAL_PROPERTIES: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_IngestionMappingName,
        association: 'INGESTION_MAPPINGNAME'
    })
    public ingestionMappingName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AdditionalPropertiesName,
        association: 'ADDITIONAL_PROPERTIES',
        accepts: ['Object']
    })
    public additionalProperties?: object;
}
